import ScreenPage from '@/page/screen/index.vue'

export default [
  {
    path: '/',
    name: 'Home',
    component: ScreenPage
  },
  {
    path: '/patrol-center',
    name: 'PatrolCenter',
    component: () => import('@/page/patrol/Patrol.vue')
  },
  {
    path: '/events-center',
    name: 'EventCenter',
    component: () => import('@/page/event/Event.vue')
  },
  {
    path: '/vendor-manage',
    name: 'vendor-manage',
    component: () => import('@/page/providers/ProviderList.vue')
  },
  {
    path: '/asset-manage',
    name: 'asset-manage',
    component: () => import('@/page/property/PropertyList.vue')
  }
]